import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=4477846a&scoped=true&"
import script from "./JImageUpload.vue?vue&type=script&lang=js&"
export * from "./JImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477846a",
  null
  
)

export default component.exports